import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Exam Scheduling|Schedule|';

export type ScheduleExamLoc =
	| 'CPScheduleExamIntellumAction'
	| 'CPScheduleExamAuthorizationError'
	| 'CPScheduleExamAuthorizationUnauthorized'
	| 'CPScheduleExamAuthorizationAuthorized'
	| 'CPScheduleExamAuthorizationAuthError'
	| 'CPScheduleExamAuthorizationAuthSuccess'
	| 'CPScheduleExamLabelFilterByGroup';

export const scheduleExamLocs: LocDefs<ScheduleExamLoc> = {
	CPScheduleExamAuthorizationError: {
		defaultValue: 'Authorization Error: Please contact support',
		description: 'Message when an exam scheduling authorization error occurs.',
		displayPath: `${dpRoot}Authorization Error`,
		displayType: 'Error',
		feature: HubFeature.ExamAuthorization,
		portal: 'CP' as LocPortal,
		htmlAllowed: false,
		shared: true,
	},
	CPScheduleExamAuthorizationUnauthorized: {
		defaultValue: 'Schedule',
		description: 'Content shown when an exam needs authorization before scheduling.',
		displayPath: `${dpRoot}Unauthorized`,
		displayType: 'Content',
		feature: HubFeature.ExamAuthorization,
		portal: 'CP' as LocPortal,
		htmlAllowed: false,
		shared: true,
		legacyName: 'Exam.Authorization/ScheduleExam.Content.Unauthorized',
	},
	CPScheduleExamAuthorizationAuthorized: {
		defaultValue: 'Schedule',
		description: 'Content shown when an exam is authorized.',
		displayPath: `${dpRoot}Authorized`,
		displayType: 'Content',
		feature: HubFeature.ExamAuthorization,
		portal: 'CP' as LocPortal,
		htmlAllowed: false,
		shared: true,
		legacyName: 'Exam.Authorization/ScheduleExam.Content.Authorized',
	},
	CPScheduleExamAuthorizationAuthError: {
		defaultValue: 'There was a problem authorizing this exam',
		description: 'Notification message shown when an exam authorization error occurs.',
		displayPath: `${dpRoot}Authorization Error Notification`,
		displayType: 'Notification',
		feature: HubFeature.ExamAuthorization,
		portal: 'CP' as LocPortal,
		htmlAllowed: false,
		shared: true,
		legacyName: 'Exam.Authorization/ScheduleExam.NotificationMessage.AuthError',
	},
	CPScheduleExamAuthorizationAuthSuccess: {
		defaultValue:
			'Thank you for your patience as we authorize this exam. This may take a few minutes.',
		description: 'Notification message shown when an exam authorization is in progress.',
		displayPath: `${dpRoot}Authorization Loading Notification`,
		displayType: 'Notification',
		feature: HubFeature.ExamAuthorization,
		portal: 'CP' as LocPortal,
		htmlAllowed: false,
		legacyName: 'Exam.Authorization/ScheduleExam.NotificationMessage.Success',
	},
	CPScheduleExamIntellumAction: {
		defaultValue: 'Schedule',
		description: 'Intellum Schedule Action',
		displayPath: `${dpRoot}Intellum Action`,
		displayType: 'Button',
		feature: HubFeature.ExamSchedulingIntellum,
		portal: 'CP' as LocPortal,
		htmlAllowed: false,
		shared: false,
	},
	CPScheduleExamLabelFilterByGroup: {
		defaultValue: 'Filter by Group',
		description: 'Label for the group filter for the exam data.',
		displayPath: `${dpRoot}Label Filter by Group`,
		displayType: 'Label',
		feature: HubFeature.ExamAuthorization,
		portal: 'CP' as LocPortal,
		htmlAllowed: false,
		shared: true,
	},
};

export const LOC_KEYS = MapLocKeys<ScheduleExamLoc>(scheduleExamLocs);
